/**
 * Messages FR pour les boîtes de dialogue
 */

module.exports = {

    role: {
        remove: {
            title: 'Êtes-vous sûr de vouloir supprimer le rôle { name } ? Les utilisateurs ayant ce rôle n\'auront plus d\'autorisation.',
            altLabel: 'Supprimer le rôle { name }.',
            error: 'Une erreur s\'est produite pendant la suppression du rôle { name }.',
            button: {
                confirm: 'Supprimer',
                cancel: 'Annuler'
            }
        }
    },

    // Modale des tutorials vidéos
    tutorialVideoTree: {
        title: 'Tutoriels vidéos',
        empty: 'Aucune vidéo de tutorial n\'est disponible.',
        takeMeetButton: {
            label: 'Besoin d\'échanger en visio avec un pro'
        },
        search: {
            fields: {
                search: 'Effectuer une recherche'
            }
        }
    },

    user: {
        requiredSubscription: {
            message: 'Pour utiliser cette fonctionnalité, vous devez disposer d\'un abonnement. Hâte de vous voir parmi nous !',
            messageWithSubscriptionTarget: 'Pour utiliser cette fonctionnalité, vous devez disposer d\'un abonnement { productName }.',
            button: {
                confirm: 'S\'abonner'
            }
        },
        sendRegistrationValidation: {
            altLabel: 'Envoyer une notification de demande de validation de son inscription à { name }.',
            title: 'Envoyer une demande de validation d\'inscription',
            content: 'Souhaitez-vous envoyer une demande de validation d\'inscription à { name } ?',
            error: 'Une erreur s\'est produite pendant l\'envoi de la notification à { name }.',
            button: {
                confirm: 'Envoyer',
                cancel: 'Annuler'
            }
        },
        sendConnectionInvitation: {
            title: 'Envoyer un mail ?',
            content: {
                init: 'Souhaitez-vous envoyer un mail d\'instruction pour que { name } initialise son mot de passe ?',
                login: 'Souhaitez-vous envoyer un mail d\'instruction pour que { name } se connecte ?'
            },
            altLabel: 'Inviter { name } à se connecter.',
            error: 'Une erreur s\'est produite pendant l\'envoi du mail à { name }.',
            button: {
                confirm: 'Envoyer',
                cancel: 'Annuler'
            }
        },
        impersonate: {
            title: 'Se connecter ?',
            content: 'Souhaitez-vous vous connecter en impersonate au compte de { name } ?',
            altLabel: 'Se connecter au compte de { name }.',
            error: 'Une erreur s\'est produite pendant la tentative de connexion au compte de { name }.',
            button: {
                confirm: 'Se connecter',
                cancel: 'Annuler'
            }
        },
        editRole: {
            title: 'Edition du rôle de { user }'
        },
        delete: {
            title: 'Êtes-vous sûr ?',
            content: 'Êtes-vous sûr de vouloir supprimer le compte de <strong>{ name }</strong> ?',
            altLabel: 'Supprimer le compte de { name }.',
            error: 'Une erreur s\'est produite pendant la suppression du compte de { name }.',
            button: {
                confirm: 'Supprimer le compte',
                cancel: 'Annuler'
            }
        },
        resetPassword: {
            title: 'Réinitialiser le mot de passe'
        }
    },

    contact: {
        remove: {
            title: 'Êtes-vous sûr ?',
            content: 'Êtes-vous sûr de vouloir supprimer le compte de { name } de vos contacts ?',
            altLabel: 'Supprimer le compte de { name }.',
            error: 'Une erreur s\'est produite pendant la suppression du compte de { name }.',
            button: {
                confirm: 'Supprimer',
                cancel: 'Annuler'
            }
        }
    },

    admin: {
        taskConfiguration: {
            edit: {
                title: 'Configuration de la tâche { name }'
            },
            group: {
                add: {
                    title: 'Créer un groupe de configuration de tâche'
                },
                edit: {
                    title: 'Édition du groupe { name }'
                },
                taskConfigurations: {
                    title: 'Édition des configurations des tâches du groupe { group }'
                }
            }
        },
        video: {
            create: {
                title: 'Ajouter une vidéo'
            },
            edit: {
                title: 'Édition de la vidéo { video }'
            },
            import: {
                title: 'Importation de vidéos'
            },
            tutorial: {
                category: {
                    create: {
                        title: 'Créer une catégorie de vidéos'
                    },
                    edit: {
                        title: 'Edition de la catégorie { category }'
                    }
                },
                question: {
                    create: {
                        title: 'Créer une question de tutorial'
                    },
                    edit: {
                        title: 'Edition de la question { question }'
                    }
                },
                video: {
                    create: {
                        title: 'Créer une vidéo de tutorial'
                    },
                    edit: {
                        title: 'Edition de la vidéo { video }'
                    },
                    remove: {
                        error: 'Une erreur s\'est produite pendant la suppression de la vidéo { video }.',
                        message: 'Êtes-vous sûr de vouloir supprimer la vidéo { video } ?'
                    }
                }
            }
        },
        publicationIdea: {
            create: {
                title: 'Ajouter une idée de publication'
            },
            edit: {
                title: 'Édition de l\'idée de publication { idea }'
            },
            import: {
                title: 'Importation d\'idées de publication'
            }
        },
        graphicalLineTemplate: {
            create: {
                title: 'Ajouter une charte graphique',
                choiceType: {
                    description: 'Choisissez un type de charte',
                    types: {
                        single: 'Image simple',
                        carousel: 'Carrousel'
                    }
                }
            },
            edit: {
                title: 'Éditer une charte',
                editVisualButton: {
                    label: 'Éditer le visuel'
                }
            },
            remove: {
                message: 'Êtes-vous sûr de vouloir supprimer la charte graphique { name } ?',
                error: 'Une erreur s\'est produite lors de la suppression de la charte graphique { name }.'
            }
        },
        agencyManager: {
            customerList: {
                title: 'Liste des clients'
            },
            affiliationCode: {
                add: {
                    title: 'Ajouter un code d\'affiliation'
                },
                edit: {
                    title: 'Edition du code d\'affiliation { code }'
                }
            }
        }
    },

    socialNetwork: {
        connectionError: 'Une erreur s\'est produite pendant la connexion au réseau social {network}. Si le problème persiste, contactez notre <a href="{ contactUrl }" title="">support technique en cliquant ici</a> ou par mail à <a href="{ contactUrl }" title="">{ contactMail }</a>.',
        selectAccounts: {
            title: 'Lier des comptes { network }',
            description: 'Sélectionnez au moins 1 compte à associer',
            empty: 'Aucun compte associé à votre profil { network } n\'a pu être trouvé.',
            error: 'Une erreur s\'est produite pendant la liaison du compte.',
            confirmationCloseModal: {
                message: 'Vous devez sélectionner au moins une page dans la liste pour utiliser un réseau.'
            }
        },
        addNetworks: {
            button: {
                altTitle: 'Ajouter un réseau.'
            },
            title: 'Ajout d\'un réseau'
        },
        howUnlink: {
            title: 'Comment délier { applicationName } de ses réseaux sociaux ?',
            instructions: {
                facebook: 'Pour délier vos réseaux sociaux Facebook et Instagram de l\'application { applicationName }, il vous faut aller sur votre compte Facebook, cliquer sur la photo de votre profil et aller dans "Paramètres et confidentialité", puis dans "Paramètres" et enfin dans "Intégrations professionnels" pour supprimer l\'application { applicationName } :',
                linkedin: 'Pour délier votre compte Linkedin de l\'application { applicationName }, il vous faut aller sur votre compte Linkedin, cliquer sur la photo de votre profil et aller dans "Préférences et confidentialité", puis dans "Confidentialité des données" et enfin dans "Autres applications" et "Services autorisés" pour supprimer l\'application { applicationName } :',
                after: 'Une fois supprimé, vous pouvez retourner sur l\'application { applicationName } dans "Mon compte" onglet "Informations essentielles" et reconnecter votre compte.'
            }
        },
        editTone: {
            title: 'Personnalisation du ton'
        },
        higherSubscriptionLevelRequired: {
            message: {
                withSubscription: 'Vous devez avoir un abonnement de niveau supérieur pour ajouter un réseau.',
                withoutSubscription: 'Vous devez avoir un abonnement pour ajouter un réseau.'
            },
            buttons: {
                subscribe: 'S\'abonner',
                changeSubscription: 'Changer l\'abonnement'
            }
        }
    },

    confirmation: {
        title: 'Êtes-vous sûr ?',
    },

    // Tâche
    task: {
        add: {
            title: 'Ajouter une publication',
            aiPublicationWithFiles: {
                title: 'Générez un post à partir d\'une image'
            },
            buttons: {
                orderPublication: {
                    label: 'Commander une publication'
                },
                addPublication: {
                    label: 'Via mes infos'
                },
                addAIPublication: {
                    standard: {
                        label: 'Via un prompt'
                    },
                    event: {
                        label: 'Via une URL'
                    }
                },
                addAiPublicationWithFiles: {
                    label: 'Via une image'
                }
            }
        },
        remove: {
            message: 'Êtes-vous sûr de vouloir supprimer la publication { title } ?',
            error: 'Une erreur s\'est produite pendant la suppression de la publication.'
        },
        validate: {
            title: 'Programmer le post',
            description: 'Vérifier les comptes des réseaux sociaux sur lesquels publier la tâche.',
            error: 'Une erreur s\'est produite pendant la validation de la tâche.',
            subscriptionRequired: 'Vous devez maintenant être abonné pour continuer à programmer des posts.',
            multipleNetworksHooks: 'Vous avez des textes différents pour vos réseaux. Si vous souhaitez les modifier, vous pouvez le faire en fermant cette boîte de dialogue.',
            buttons: {
                cancelPublications: {
                    label: 'Déprogrammer le post'
                }
            }
        },
        // Demande de régénération complète par l'IA
        regenerateSuggestion: {
            title: 'Demande de régénération complète via l\'IA',
            credits: 'Une régénération complète utilisera { credits } crédits.'
        },
        editSuggestion: {
            title: 'Edition des paramètres de la tâche { title }',
            error: 'Une erreur s\'est produite pendant l\'enregistrement de la tâche'
        },
        convertSuggestionInReturn: {
            title: 'Avant votre demande de retour',
            description: 'Veuillez définir les comptes des réseaux sociaux sur lesquels publier la tâche.',
            error: 'Une erreur s\'est produite pendant le traitement de votre demande.',
            convert: {
                button: {
                    label: 'Demander un retour'
                }
            }
        },
        filesPublicationRequired: {
            description: 'Pour valider le post, vous devez d\'abord valider un visuel.'
        },
        hookChoicePublicationRequired: {
            description: 'Pour valider le post, vous devez choisir l\'accroche que vous souhaitez utiliser.'
        },
        planning: {
            startTutorial: {
                description: 'En attendant la génération<br />de votre planning, prenez quelques<br />instants pour découvrir<br />votre planning 💡',
                button: {
                    cancel: 'Passer',
                    start: 'C\'est parti !'
                }
            }
        },

        publicationPreview: {
            title: 'Voir le rendu de ma publication',
            noNetwork: 'Les réseaux de la publication n\'ont pas pu être déterminés.',
            noHook: 'Impossible de déterminer la prévisualisation pour ce réseau.',
            header: {
                linkedin: {
                    carousel: {
                        title: 'Nom du carrousel',
                        countElements: '{ count } pages'
                    }
                }
            },
            hook: {
                showMore: {
                    facebook: 'En voir plus',
                    instagram: '... plus',
                    linkedin: '... plus'
                }
            },
            identity: {
                subscriber: '{ count } abonnés'
            },
            likes: {
                action: {
                    facebook: 'J\'aime',
                    instagram: 'J\'aime',
                    linkedin: 'J\'aime'
                }
            },
            comments: {
                action: {
                    facebook: 'Commenter',
                    instagram: 'Ajouter un commentaire...',
                    linkedin: 'Commenter'
                },
                counter: {
                    facebook: '{ count } commentaires',
                    instagram: 'Afficher les { count } commentaires',
                    linkedin: '{ count } commentaires'
                }
            },
            shares: {
                action: {
                    facebook: 'Partager',
                    linkedin: 'Republier'
                },
                counter: {
                    facebook: '{ count } partages'
                }
            },
            sends: {
                action: {
                    linkedin: 'Envoyer'
                }
            }
        },

        list: {
            firstTime: {
                title: 'Pour créer votre premier post...',
                selectTask: 'Sélectionnez un post dans la liste\npour l\'éditer ou le programmer',
                schedule: 'Une fois l\'édition terminée,\ncliquez sur "Programmer" !',
                button: {
                    close: {
                        label: 'J\'ai compris !'
                    }
                }
            },
            generateNewIdeas: {
                title: 'Génération de nouvelles idées',
                generating: 'Cela peut prendre quelques instants',
                counter: 'Idées générées : { count } / { total }'
            },
            generateNewIdeasSettings: {
                title: 'Paramètres de génération des nouvelles idées',
                button: {
                    random: {
                        label: 'Générer aléatoirement'
                    },
                    custom: {
                        label: 'Choisir vos sujets'
                    }
                }
            }
        },

        boostPublication: {
            facebook: {
                title: 'Boost de la publication sur Facebook ou Instagram',
                loadBusinessAccountsError: 'Vos comptes Business n\'ont pas pu être récupérés.',
                loadAdvertAccountsError: 'Les comptes publicitaires n\'ont pas pu être récupérés.',
                advertCreated: 'La publicité a été configurée sur votre compte publicitaire. Vous devriez pourvoir l\'éditer depuis votre compte Business.',
                form: {
                    error: 'Une erreur s\'est produite pendant l\'enregistrement de la publicité.',
                    fields: {
                        businessAccount: 'Compte Business',
                        advertAccount: 'Compte publicitaire',
                        publication: 'Publication de la page à promouvoir',
                        beginAt: 'Date de début de la campagne',
                        endAt: 'Date de fin de la campagne',
                        dailyBudget: 'Budget quotidien',
                        ageMin: 'Âge minimum',
                        ageMax: 'Âge maximum',
                        gender: 'Genre à cibler',
                        country: 'Pays à cibler',
                        objective: 'Objectif',
                        cities: 'Villes à cibler',
                        interests: 'Centres d\'intérêt à cibler'
                    },
                    city: {
                        placeholder: 'Rechercher une ville'
                    },
                    interest: {
                        placeholder: 'Rechercher un centre d\'intérêt'
                    },
                    gender: {
                        all: 'Tous',
                        male: 'Masculin',
                        female: 'Féminin'
                    },
                    objective: {
                        outcomeAwareness: 'Notoriété de la marque',
                        outcomeEngagement: 'Engagement',
                        outcomeLeads: 'Génération des leads',
                        outcomeTraffic: 'Génération de trafic'
                    }
                }
            }
        }
    },

    ai: {
        // Initialisation de l'activation de l'Intelligence Artificielle
        init: {
            title: 'Félicitation et très heureux de vous voir parmi nous 🥳',
            description: 'Vous avez le choix : demandez à l\'IA Tookano de générer votre planning de posts ou bien demandez la création de publications sur mesure par nos Community managers.',
            savingError: 'Une erreur s\'est produite pendant l\'enregistrement.',
            waitingMessage: 'Merci de patienter quelques instants, l\'IA Tookano est en train d\'analyser votre site web. Dans quelques secondes, apparaitra le bouton "Go".',
            choices: {
                enable: {
                    label: 'Go !'
                },
                disable: {
                    label: 'Je demande la création de posts sur mesure'
                }
            },
            goToHome: {
                label: 'Accéder au Dashboard'
            }
        },
        // Validation des données issues de l'IA
        validationData: {
            title: 'Validation de vos informations',
            description: 'Il semble qu\'on se connaisse déjà un peu, non ? 😋<br />L\'IA {applicationName} vous a-t-elle bien comprise ?',
            loadFormatsError: 'Une erreur s\'est produite pendant le chargement des données.',
            subjects: {
                description: 'Dernière étape, validez les sujets pour générer vos posts'
            }
        },
        // Définition du schéma des produits récupérés depuis une URL
        productsSchema: {
            title: 'Champs de correspondance des produits',
            description: 'Indiquez pour chaque champs une correspondance dans votre fichier.'
        },
        // En attente des sujets de publication
        searchingSubjects: {
            title: 'Préparation de votre planning',
            description: 'Nous recherchons des sujets de publications pour les prochaines semaines. Vous serez notifiés pour les valider ou les modifier.',
            button: {
                close: {
                    label: 'Accéder au Dashboard'
                }
            }
        },
        // Validation des sujets de publication
        subjectsValidation: {
            title: 'Validation de vos sujets de publication',
            loadingAIThematicsError: 'Une erreur s\'est produite pendant le chargement des thématiques.',
            loadingAIAudiencesError: 'Une erreur s\'est produite pendant le chargement des cibles.',
            loadingFormatsError: 'Une erreur s\'est produite pendant le chargement des formats.',
            requiredCreditsSubscription: {
                message: 'Vous devez maintenant être abonné pour générer la suite de votre planning.',
                buttons: {
                    help: 'Besoin d\'échanger',
                    demo: 'Besoin d\'une démo'
                }
            }
        },
        // Régénération d'un sujet par l'IA
        regenerationSubjectConfirmation: {
            title: 'Régénération d\'un sujet',
            credits: '0 crédit sont nécessaires pour régénérer le nom du sujet. | 1 crédit est nécessaire pour régénérer le nom du sujet. | { count } crédits sont nécessaires pour régénérer le nom du sujet.',
            confirm: 'Êtes-vous sûr de vouloir régénérer le sujet { subject } ?',
            error: 'Le sujet n\'a pas pu être régénéré.'
        },
        // Planning en cours de génération
        planningComputing: {
            title: 'Votre planning est en cours de création',
            description: 'L\'IA Tookano est en train de construire votre planning. Il sera bientôt disponible. Cela peut prendre quelques minutes...',
            alert: {
                title: '{ user } vous serez alerté dès que les plannings seront créés dans leur totalité.',
                description: 'Toutefois, les premiers posts apparaitront dans votre interface après avoir validé les sujets.'
            }
        },
        // Informations après la demande de génération d'un planning
        planningGeneratingInformations: {
            about: 'L\'IA { applicationName } est en train générer vos sujets.',
            mail: 'Vous recevrez un email pour les valider dans quelques minutes.',
            instruction: 'Vous pourrez aussi les retrouver en cliquant sur le bouton "Valider mes sujets".'
        },
        // Paramètre de l'IA pour le client connecté
        settings: {
            title: 'Ligne éditoriale',
            description: 'L\'IA { applicationName } a généré une ligne éditoriale à partir des paramètres suivants. Vous pouvez les modifier !'
        },
        // Paramètres pour le style d'écriture
        writingStyle: {
            title: 'Style rédactionnel',
            summary: {
                title: 'Synthèse style rédactionnel',
                informations: 'Retrouvez ici les styles d\'écritures qui seront utilisés pour la rédaction de vos posts. Vous pouvez les modifier à tout moment pour la génération de vos futurs posts.'
            },
            noNetwork: 'Vous n\'avez pas lié de réseau social à votre compte.',
            network: {
                prerequisites: {
                    about: 'Avant de vous présenter des styles d\'écriture, vous êtes plutôt :',
                    error: 'Une erreur s\'est produite pendant la génération du style d\'écriture.',
                    fields: {
                        formality: 'Tutoiement / Vouvoiement',
                        pronouns: 'Pronoms',
                        languageRegister: 'Registre de langue',
                        tones: 'Tons'
                    }
                },
                post: {
                    categoryTitle: 'Type de post : { category }',
                    explications: 'Parmi les exemples de posts ci-dessous, sélectionnez-en un en cliquant sur le bouton Suivant. Le post servira pour définir le style d\'écriture de la catégorie "post { category }". En cliquant sur une légende, vous pouvez en modifier le contenu.',
                    saveChoice: {
                        error: 'Une erreur s\'est produite pendant la prise en compte de votre choix.',
                        button: {
                            label: 'Valider cette légende'
                        }
                    }
                },
                summary: {
                    title: {
                        style: 'Style d\'écriture',
                        post: 'Exemple de post'
                    }
                }
            }

        },
        // Informations manquantes
        missingInformations: {
            title: 'Informations manquantes',
            description: 'Une description d\'activité est nécessaire pour générer un planning.',
            button: {
                goToSettings: {
                    label: 'Compléter mon profil'
                }
            }
        },

        editPostImage: {
            title: 'Edition de l\'image "{ title }"',
        },
        addPostImages: {
            title: 'Ajouter des images'
        },
        removePostImage: {
            confirmation: {
                message: 'Êtes-vous sûr de vouloir supprimer cette image ?'
            }
        },

        thematic: {
            regeneration: {
                confirmation: {
                    message: 'Êtes-vous sûr de vouloir régénérer la thématique { thematic } ? Les sujets de cette thématiques seront également régénérés et vous ne pourrez pas utiliser les anciens sujets.',
                    error: 'Une erreur s\'est produite lors de la régénération de la thématique { thematic }.'
                }
            }
        }
    },

    graphicalLineTemplate: {
        /* Sélection d'une charte graphique */
        list: {
            title: 'Éditer une charte',
            empty: 'Aucune charte graphique n\'est disponible.',
            editVisualButton: {
                label: 'Editer le visuel'
            }
        },
        editDefaultTemplatesByCategory: {
            title: 'Vos modèles Graphiques { category }',
            description: 'Sélectionner vos modèles Graphique pour vos posts { category }.<br />Jusqu\'à 3 maximum par type de posts. Ces modèles graphiques viendront s\'insérer directement lors de la génération de votre planning éditorial mensuel.'
        }
    },

    themes: {
        list: {
            title: 'Liste des thèmes',
            empty: 'Aucun thème n\'a été trouvé.'
        },
        edit: {
            title: 'Edition du thème { name }'
        },
        add: {
            title: 'Ajouter un thème'
        },
        remove: {
            error: 'Une erreur s\'est produite pendant la suppression du thème.',
            message: 'Êtes-vous sûr de vouloir supprimer le thème { theme } ?'
        }
    },

    agencyCustomer: {
        enableCustomer: {
            title: 'Activation d\'un compte client'
        },
        editCustomer: {
            title: 'Édition du compte client { name }'
        }
    },

    requiredPaymentInformations: {
        title: 'Informations de paiement nécessaires'
    },

    enableTrialPeriod: {
        title: 'Activation de la période d\'essai',
        description: 'Pour activer votre période d\'essai de { duration } jours, nous avons besoin de vos coordonnées bancaires. Vous ne serez pas facturés pendant votre période d\'essai, ni si vous souhaitez annuler celle-ci. Vous pouvez arrêter votre période d\'essai à tout moment depuis la page <a href="{ accountUrl }" title="">Mon compte</a>. Si vous n\'annulez pas votre période d\'essai, un abonnement de { price } HT mensuel sera prélevé chaque mois, jusqu\'à l\'annulation de l\'abonnement. Un mail, à l\'adresse { email }, vous sera envoyé une semaine avant la fin de la période d\'essai, vous permettant de l\'annuler si vous le souhaitez.',
        error: 'Une erreur s\'est produite pendant l\'activation de votre période d\'essai.'
    },
    repositoryFile: {
        add: {
            title: 'Ajouter un fichier au répertoire'
        },
        edit: {
            title: 'Édition du fichier { name }'
        }
    }
};
